module.exports = __webpack_public_path__ + "static/media/icon-risk-ok.88f55677.png";